import Logo from "@/public/images/Isee_Logo.svg";

const versionIcons = {
  beta: <Logo />,
  stable: <Logo />,
  // Add more versions as needed
};

const defaultIcon = <Logo />;

export function getVersionIcon(version: string) {
  return versionIcons[version] || defaultIcon;
}
